export default {
  navigationBarTitleText: '证件识别',
};
